import { useFeatureGate } from '@statsig/expo-bindings';
import { isWeb, ScreenContainer } from 'smoothie';

import { useUserAuthorization } from '../../auth/hooks/useUserAuthorization';
import useGetExistingIncomeSplitConfigs from '../../banking/components/income-split/hooks/useGetIncomeSplitConfigs';
import { FeatureFlags } from '../../feature-flags/FeatureFlags';
import {
    NotificationChannel,
    NotificationType,
} from '../types/UserNotificationChannel';
import NotificationsSection from './NotificationsSection';

const NotificationSettingsScreen = () => {
    const { accessToRestrictedCapabilities } = useUserAuthorization();
    const { value: enableCashCardNotifications } = useFeatureGate(
        FeatureFlags.ENABLE_CASH_CARD_NOTIFICATIONS,
    );
    const { value: enableIncomeSplitNotifications } = useFeatureGate(
        FeatureFlags.ENABLE_INCOME_SPLIT_VISUALS,
    );
    const { value: enableGuidanceSessionReminderSMS } = useFeatureGate(
        FeatureFlags.ENABLE_GUIDANCE_SESSION_REMINDER_SMS,
    );

    const { incomeSplitConfigs } = useGetExistingIncomeSplitConfigs();

    const guideMessagingNotificationChannels = [
        ...(isWeb ? [] : [NotificationChannel.PUSH]),
        NotificationChannel.EMAIL,
    ];
    const guidanceSessionsNotificationChannels = [
        ...(isWeb ? [] : [NotificationChannel.PUSH]),
    ];
    if (enableGuidanceSessionReminderSMS) {
        guidanceSessionsNotificationChannels.push(NotificationChannel.SMS);
    }

    const bankCardNotificationChannels = [
        ...(isWeb ? [] : [NotificationChannel.PUSH]),
    ];
    const incomeSplitNotificationChannels = [
        ...(isWeb ? [] : [NotificationChannel.PUSH]),
    ];

    return (
        <ScreenContainer title="Notifications" hasBackButton={true}>
            {accessToRestrictedCapabilities.guideMessaging &&
                !!guideMessagingNotificationChannels.length && (
                    <NotificationsSection
                        title="Guide messages"
                        type={NotificationType.GUIDE_MESSAGE}
                        channels={guideMessagingNotificationChannels}
                    />
                )}
            {accessToRestrictedCapabilities.guidanceSessions &&
                !!guidanceSessionsNotificationChannels.length && (
                    <NotificationsSection
                        title="Upcoming sessions"
                        type={NotificationType.UPCOMING_SESSION}
                        channels={guidanceSessionsNotificationChannels}
                    />
                )}
            {!!bankCardNotificationChannels.length &&
                enableCashCardNotifications && (
                    <>
                        <NotificationsSection
                            title="Card purchases"
                            type={NotificationType.CARD_TRANSACTION_PENDING}
                            channels={bankCardNotificationChannels}
                        />
                        <NotificationsSection
                            title="Card declined"
                            type={NotificationType.CARD_TRANSACTION_DECLINED}
                            channels={bankCardNotificationChannels}
                        />
                        <NotificationsSection
                            title="Cash back posted"
                            type={NotificationType.CASHBACK_REWARD_POSTED}
                            channels={bankCardNotificationChannels}
                        />
                        <NotificationsSection
                            title="Interest paid"
                            type={NotificationType.INTEREST_POSTED}
                            channels={bankCardNotificationChannels}
                        />
                    </>
                )}
            {!!incomeSplitNotificationChannels.length &&
                enableIncomeSplitNotifications &&
                incomeSplitConfigs.length > 0 && (
                    <NotificationsSection
                        title="Income Split"
                        type={NotificationType.INCOME_SPLIT_EXECUTED}
                        channels={incomeSplitNotificationChannels}
                    />
                )}
        </ScreenContainer>
    );
};

export default NotificationSettingsScreen;
